import React from 'react';

/**
 * Token-based order status badge. Single source of truth for status color +
 * label across OrderList, CustomerProfile and ExecutorProfile.
 */
const config = {
  pending:     { label: 'Ожидает',  cls: 'text-status-pending bg-status-pending-muted border-status-pending/20' },
  accepted:    { label: 'Принят',   cls: 'text-status-accepted bg-status-accepted-muted border-status-accepted/20' },
  in_progress: { label: 'В работе', cls: 'text-status-progress bg-status-progress-muted border-status-progress/20' },
  completed:   { label: 'Завершён', cls: 'text-status-done bg-status-done-muted border-status-done/20' },
  cancelled:   { label: 'Отменён',  cls: 'text-status-cancelled bg-status-cancelled-muted border-status-cancelled/20' },
};

const StatusBadge = ({ status, className = '' }) => {
  const c = config[status] || {
    label: status,
    cls: 'text-text-tertiary bg-surface-3 border-border-subtle',
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-xs font-medium ${c.cls} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {c.label}
    </span>
  );
};

export default StatusBadge;
